import React, { useEffect } from 'react';
import Routes from './routes';
import AdministrationRoutes from './components/administration/AdministrationRoutes';
import Login from './components/login/LoginPage';
import ChangePassword from './components/login/ChangePassword';
import TwoFactorAuthentication from './components/login/TwoFactorAuthetication';
import clientServices from './services/clientServices';
import messages from './commons/constMessages';
import socialService from './api/services/socialServices';
import { useRecoilState } from 'recoil';
import { userAtom } from './atoms/userAtom';

const Start = () => {
  const [user] = useRecoilState(userAtom);

  useEffect(() => {
    if (user?.accessInfo?.accessToken) {
      socialService.postPeriodicSync();
    }
  }, [user?.accessInfo?.accessToken]);

  const getComponent = () => {
    let errorMessage = '';
    if (user.isAuth && !clientServices.persistEndpoint(user)) {
      errorMessage = messages.ErrMultiplasSecoes;
    }

    if (user.changePassword) {
      return <ChangePassword />;
    }

    if (!user.isAuth && user.twoFactorAuthentication ) {
      return <TwoFactorAuthentication errorMessage={errorMessage} />;
    }

    if (!user.isAuth || errorMessage) {
      return <Login errorMessage={errorMessage} />;
    }

    return !user.accessingAdministrationMode ? <Routes /> : <AdministrationRoutes />;
  };

  return getComponent();
};

export default Start;